import { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import {
  Card,
  CardBody,
  FormGroup,
  Label,
  Row,
  Col,
  Table,
  Button,
} from 'reactstrap'
import DatePicker from 'reactstrap-date-picker'
import Preloader from '../../components/modules/loader'
import CustomSelect from '../../components/elements/CustomSelect'
import MainContainer from '../../components/modules/containers/MainContainer'
import { patientHome } from '../../breadcrumRoutes.js'
import { getReport } from '../../api/report'
import { getMembers } from '../../api/member'
import { userRoles } from '../../mock-data/roles'
import ExportReport from '../../excel-export/exportReport'

const Index = () => {
  const [members, setMembers] = useState([])
  const [loading, setLoading] = useState(false)
  const [report, setReport] = useState([])
  const [member, setMember] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEnddate] = useState('')
  const history = useHistory()
  const location = useLocation()
  let memberOptions = members?.map((element) => {
    return {
      value: element.id,
      label: `${element.username} (${
        userRoles.find((role) => role.id == element.role)?.name
      })`,
    }
  })

  useEffect(() => {
    async function fetchApi() {
      setLoading(true)
      let responseMember = await getMembers()
      setMembers(responseMember)
      setLoading(false)
    }
    fetchApi()
  }, [location])

  const searchData = async () => {
    var params = {}
    if (startDate && endDate) {
      params.startDate = startDate
      params.endDate = endDate
    }
    if (member) {
      params.member_id = member
    }
    let reportResponse = await getReport(params)
    setReport(reportResponse)
  }

  return (
    <>
      {loading && <Preloader />}
      {!loading && (
        <MainContainer breadcrums={patientHome}>
          <Card>
            <CardBody>
              <Row>
                <Col md={{ size: 3 }}>
                  <FormGroup>
                    <Label for="member">Member</Label>
                    <CustomSelect
                      options={memberOptions}
                      onChange={(val) => setMember(val.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={{ size: 3 }}>
                  <FormGroup>
                    <Label for="startdate">Start Date</Label>
                    <DatePicker
                      onChange={(value) => setStartDate(value)}
                      value={startDate}
                    />
                  </FormGroup>
                </Col>
                <Col md={{ size: 3 }}>
                  <FormGroup>
                    <Label for="startdate">End Date</Label>
                    <DatePicker
                      onChange={(value) => setEnddate(value)}
                      value={endDate}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <br />
                    <Button onClick={() => searchData()}>Search</Button>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {report.length > 0 && (
            <Row className="mt-3">
              <Col md={{ size: 6, offset: 3 }}>
                <Card>
                  <CardBody>
                    <Table>
                      <tr>
                        <td>Visit Person</td>
                        <td>
                          {members.find((m) => m.id === member)?.username}
                        </td>
                      </tr>
                      {report.map((r) => {
                        return (
                          <tr>
                            <td>{r.township.short_code}</td>
                            <td>{r.total}</td>
                          </tr>
                        )
                      })}
                    </Table>
                      <ExportReport visitPerson={members.find((m) => m.id === member)?.username} isDisabled={!report ? true : false} datasets={report}/>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </MainContainer>
      )}
    </>
  )
}

export default Index
